import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class DpcCarousel extends React.Component {

    constructor(props) {
        super(props);
        this.settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: Math.min(this.props.itemsPerPage, this.props.itemsLength),
            slidesToScroll: 1,
            nextArrow: <span className="sr-only">Successivo</span>,
            prevArrow: <span className="sr-only">Precedente</span>,
            responsive: [{
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 4
                }
            }],
            autoplay: true,
            cssEase: "linear",
            autoplaySpeed: 2000,
        };
    }

    render() {
        return (
            <section className="container-fluid slider-banner">
                <h3 className="d-none">Link utili ai siti esterni</h3>
                <div className="container">
                    <div className="px-custom">
                        <div className="it-carousel-wrapper">
                            <div className="it-carousel-all it-img-card">
                                <Slider {...this.settings}>
                                    {Array.isArray(this.props.items) && this.props.items.map(img =>
                                        <div className="it-single-slide-wrapper">
                                            <div className="card-wrapper">
                                                <div className="card card-img no-after">
                                                    <div className="img-responsive-wrapper">
                                                        <div className="img-responsive">
                                                            <div className="img-wrapper">
                                                                <a href={img.slug} title={img.title}>
                                                                    <img alt={img.alt} src={img.fluid?.src}/>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

}
